import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { parseInt } from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { PartyService, SalesOrderService } from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "payment-voucher",
  templateUrl: "./paymentVoucher.html",
})
export class paymentVoucher implements OnInit {
  agentList: any;
  agentFfilterList: any;
  paymentModeList = ["NEFT", "CHEQUE", "DD", "CASH"];
  teamList = ["PRIME", "PREMIUM"];
  partyList = [];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  isApiCalled: boolean = false;
  billDetails: any;
  spl_Bills: any;
  trims_Bills: any;

  initialbillDetails: any;
  canShow: boolean = false;
  total_det: boolean = false;
  findata_exist: boolean = false;
  commDetailsLength: number = 0;
  showCommissionPage: boolean = false;
  returnBillDetails: any;
  outstandingBillDetails: any;
  totalDiscountDetails = {
    no_of_bills: 0,
    totalDiscount: 0
  };
  partialBillDetails = [];
  othersDiscountDeduction: number = 0;
  discdiff_amt: number = 0;
  spl_discDed: number = 0;
  othersDiscount: number = 0;
  selectedBillDetails: any;
  selectedSplBills = [];
  selectedTrimsBills = [];

  commDetails: any;
  returnDedDetails: any;
  returnDedDetailsBackUp: any;
  viewDetails: any;
  nonSelectedBillDetails: any;
  tot_data = {
    inv_tot: 0,
    goods_tot: 0,
    tax_tot: 0,
    sale_tot: 0,
    earnd_tot: 0,
    act_tot: 0,
    diff_tot: 0,
    partial_tot: 0,
    balsale_tot: 0,
    retsale_tot: 0,
    spldisc_tot: 0
  };
  fin_year_data = {
    march_net: 0,
    march_tax: 0,
    march_sale: 0,
    march_retsale: 0,
    march_partial: 0,
    apr_net: 0,
    apr_tax: 0,
    apr_sale: 0,
    apr_retsale: 0
  };
  voucherData = {
    ref_no: "",
    ref_date: "",
    party_name: "",
    party_id: 0,
    team: "",
    agent: "",
    agent_id: 0,
    payment_mode: "",
    bank_name: "",
    bank_ref_no: 0,
    amount: 0,
    disper: 0,
    pay_id: 0,
    totalSelectedAmt: 0,
    othersTotAmt: 0,
    totalRetAmt: 0,
    total_pending: 0,
    cour_det_id: 0,
    pass_date: "",
    rec_date: "",
    spl_d: "",
    max_per: "",
    max_per1: ""
  };

  commissionDetails = {
    total_commission: 0,
    inv_commission: 0,
    return_deduction: 0,
    spl_commission_totamt: 0,
    trims_ded_totamt: 0,
    party_dis_exceeds: 0,
    extra_dis_deduction: 0,
    exceeds_from_days: 0,
    othersDiscountDeduction: 0,
    total_commission_pending: 0,
    total_deduction: 0,
    exceedisc_ded: 0,
    discdiff_amt: 0,
    spl_discDed: 0
  };

  othersAmount = [
    {
      value: 0,
      label: "CASH",
    },
    {
      value: 0,
      label: "DISCOUNT",
    },
    {
      value: 0,
      label: "COLLEC.CHARGES",
    },
    {
      value: 0,
      label: "BOXLESS",
    },
    {
      value: 0,
      label: "SHORTAGE",
    },
    {
      value: 0,
      label: "EXCESS",
    },
    {
      value: 0,
      label: "IF ANY",
    },
  ];

  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;

    if (this.mode == "View" || this.mode == "Cheque Return") {
      this.voucherData = this._params["data"];
      this.voucherData.agent = this.voucherData["agent_name"];
      this.voucherData.max_per = this.voucherData["max_per"];
      this.voucherData.max_per1 = this.voucherData["max_per"];




      // this.voucherData.ref_date = this.datePipe.transform(
      //   this.voucherData["ref_date"],
      //   "yyyy-MM-dd"
      // );
      // this.voucherData.ref_date = this.voucherData["ref_date"].toString();

      // this.voucherData.ref_date = this.datePipe.transform(
      //   this.voucherData["ref_date"],
      //   "yyyy-MM-dd"
      // );
      // this.voucherData.amount = this.voucherData["payment"];
      // console.log(this.voucherData, "Check First Time Max_per")
      this.getViewPaymentVoucherList();
    }
    else if (this.mode == "Commission_View") {
      this.voucherData = this._params["data"];
      this.voucherData.agent = this.voucherData["agent_name"];
      this.voucherData.amount = this.voucherData["payment"];
      this.voucherData.ref_date = this.voucherData["entry_date"];
      this.voucherData.team = this.voucherData["inch_team"];
      this.voucherData.payment_mode = this.voucherData["payment_mode"];
      this.voucherData.bank_name = this.voucherData["bank_name"];
      this.voucherData.bank_ref_no = this.voucherData["bank_ref_no"];
      this.voucherData.amount = this.voucherData["tot_amount"];
      this.voucherData.spl_d = this.voucherData["spl_d"];
      this.voucherData.max_per = this.voucherData["max_per"];
      this.voucherData.max_per1 = this.voucherData["max_per"];



      this.getViewPaymentVoucherList();

    }
    else if (this.mode == "PDC_Add") {
      let objectdata = this._params["data"];
      this.voucherData.agent = objectdata["agent_name"];
      this.voucherData.party_name = objectdata["party_code"];
      this.voucherData.party_id = objectdata["party_id"];
      this.voucherData.agent_id = objectdata["agent_id"];
      this.voucherData.amount = objectdata["amount"];
      this.voucherData.ref_date = objectdata["rec_date"];
      this.voucherData.team = objectdata["team"];
      this.voucherData.payment_mode = objectdata["payment_type"];
      this.voucherData.bank_name = objectdata["deposit_bank"];
      this.voucherData.bank_ref_no = objectdata["chq_no"];
      this.voucherData.cour_det_id = objectdata["cour_det_id"];
      // this.voucherData.pass_date = objectdata["pass_date"];
      this.voucherData.bank_ref_no = objectdata["chq_no"];
      // this.voucherData.amount = this.voucherData["tot_amount"];





    }
 
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  invdtControl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private partyService: PartyService,
    private salesinvservice: SalesInvoiceService
  ) { }
  ngOnInit() {

    if (this.mode == "Add") {
      this.getAuto();

      this.voucherData.ref_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
    }
    else if (this.mode == "PDC_Add") {
      this.voucherData.ref_date = this.datePipe.transform(
        this.voucherData.ref_date,
        "yyyy-MM-dd"
      );
      this.mode = 'Add'
      this.getAuto();
    }

    this.getSalesParty();
    this.getAgentList();

  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }

  getAuto() {
    let params = {
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    this.salesservice.getAutoPaymentVoucher(params).then((res: any) => {
      this.voucherData.ref_no = res;
    });
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      type: 'paymentVoucher'
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  onSelectPartyName(party_code) {
    let partylist = _.filter(this.partyList, { party_code: party_code });
    if (partylist.length > 0) {
      this.voucherData.agent_id = partylist[0]["agent_id"];
      this.voucherData.party_id = partylist[0]["genLedid"];
      this.voucherData.disper = partylist[0]["discount"];

      let fitem = _.find(this.agentList, {
        genLedid: this.voucherData.agent_id,
      });
      this.voucherData.agent = fitem["name"];
      this.voucherData.team = partylist[0]["incharger"];
    }

    $("#team").focus();
  }
  getAgentList() {
    let that = this;
    that.partyService.getAgentList({}).then((res: any) => {
      that.agentList = [...res];
      that.agentFfilterList = [...res];
    });
  }
  onSelectAgentName(agent_name) {
    let fitem = _.find(this.agentList, { name: agent_name });
    this.voucherData.agent_id = fitem["genLedid"];
    $("#payment_mode").focus();
  }

  // onSelectTeam(team) {
  //   this.agentFfilterList = this.agentList.filter((el) => el.incharger == team);
  //   $("#payment_mode").focus();
  // }

  showDetails() {
    if (this.voucherData.party_id != 0) {
      this.canShow = true;
      this.restoreBillDetails();
    } else {
      this.canShow = false;
      swal("Make sure that all entries are entered");
    }
  }
  showCommissionDetails() {
    // if (this.total_pending == 0) {
    this.setExtraDisDeductions();
    this.setExceedsDaysDeductions();
    this.setReturnDedDetails();
    this.setExceedsFinalDaysDetails();
    this.setExceeddiscountDed();
    this.setOthersDiscountDetails();
    this.TrimsbillDet();
    this.SplbillComm()
    this.setReturnsaleAmtDet()
    this.showCommissionPage = true;
    this.canShow = false;
    this.setCommissionDetails();

    // }
  }
  showBillDetails() {
    this.showCommissionPage = false;
    this.canShow = true;
  }

  setCommissionDetails() {
    this.commissionDetails = {
      total_commission: 0,
      inv_commission: 0,
      return_deduction: 0,
      spl_commission_totamt: 0,
      trims_ded_totamt: 0,
      party_dis_exceeds: 0,
      extra_dis_deduction: 0,
      exceeds_from_days: 0,
      othersDiscountDeduction: 0,
      total_commission_pending: 0,
      total_deduction: 0,
      exceedisc_ded: 0,
      discdiff_amt: 0,
      spl_discDed: 0
    };
    // Foreach Through An Selected Array With Partial (partial > 0)
    // if (this.partialBillDetails.length > 0 && this.mode == "Add") {
    //   this.selectedBillDetails.forEach((el, ind) => {
    //     el["partial_saleamt"] = 0;
    //     this.partialBillDetails.forEach((e, index) => {
    //       if (el.dcid == e.dcid) {
    //         e["partial_saleamt"] = (Number(e.invoice_sale_amount) - e.pending_amount) - (Number(this.othersAmount[1].value));
    //         el.partial_saleamt = e["partial_saleamt"]
    //         el.commission_amt = (e.partial_saleamt * (Number(e.commission) / 100)).toFixed(2);
    //         //Second Time Partial Payment recieved Invoice
    //         if ((Number(el.pending_amount) < Number(el.total_amount)) && Number(el.pending_amount > 0)) {
    //           el["partial_saleamt"] = (Number(el.pending_amount) - e.pending_amount) - (Number(this.othersAmount[1].value));
    //           el.commission_amt = (el.partial_saleamt * (Number(el.commission) / 100)).toFixed(2);
    //         }
    //       }
    //       else {
    //         if ((Number(el.pending_amount) < Number(el.total_amount)) && Number(el.pending_amount > 0)) {
    //           // el["partial_saleamt"] = Number(el.pending_amount) - e.pending_amount;

    //           el.commission_amt = ((el.pending_amount - Number(this.othersAmount[1].value)) * (Number(el.commission) / 100)).toFixed(2);
    //           el.invoice_sale_amount = el.pending_amount
    //         }
    //       }
    //     })
    //   });
    // }


    if (this.partialBillDetails.length > 0) {
      this.selectedBillDetails.forEach((el, ind) => {
        el["partial_saleamt"] = 0;
        this.partialBillDetails.forEach((e, index) => {
          if (el.dcid == e.dcid) {
            // e["sale_amt"] = Number(el.pending_amount) - Number(el.taxamt);
            if (Number(e["bal_tax"]) > 0) {
              el.taxamt = e["bal_tax"];
            }
            e["sale1_amt"] = Number(el.pending_amount) - Number(el.taxamt);
            if (Number(e.sale1_amt) < Number(e.pending_amount)) {

              e["sale_amt"] = 0;
              e["partial_saleamt"] = 0;
              e["bal_tax"] = -(Number(e.sale1_amt) - Number(e.pending_amount));

            }
            // else if (Number(el.pending_amount) < Number(el.total_amount) && Number(e.sale1_amt) > Number(e.pending_amount)) {
            else if (Number(el.pending_amount) < Number(el.total_amount) && (Number(e.sale1_amt) > Number(e.pending_amount) || Number(e["bal_tax"] == 0))) {
              e["sale_amt"] = Number(el.pending_amount) - Number(e.pending_amount);
              e["partial_saleamt"] = e["sale_amt"];
              el.partial_saleamt = e["partial_saleamt"]
            }

            else {

              e["sale_amt"] = Number(el.pending_amount) - Number(el.taxamt);
              e["partial_saleamt"] = (Number(e.sale_amt) - e.pending_amount)
              el.partial_saleamt = e["partial_saleamt"]
            }
            // e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
            // e["sale1_amt"] = Number(e.total_amount) - Number(e.taxamt);
            // if (Number(e.sale_amt) > Number(e.sale1_amt)) {
            //   e["sale_amt"] = Number(e.pending_amount);
            // }

            // e["sale_amt"] = Number(el.pending_amount);
            // if (Number(e.pending_amount) < Number(e.sale_amt)) {
            //   e["sale_amt"] = Number(el.pending_amount)
            // }
            // else {
            //   e["sale_amt"] = Number(el.pending_amount) - Number(el.taxamt);
            // }



            el.commission_amt = (el.partial_saleamt * (Number(el.commission) / 100)).toFixed(2);
            el.maxcomm_amt = (el.partial_saleamt * (Number(this.voucherData.max_per) / 100)).toFixed(2);

            // el["diff"] = (Number(el.maxcomm_amt) - Number(el.commission_amt)).toFixed(2);


            //Second Time Partial Payment recieved Invoice
            // if ((Number(el.pending_amount) < Number(el.total_amount)) && Number(el.pending_amount > 0)) {
            //   el["partial_saleamt"] = (Number(el.pending_amount) - e.pending_amount) - (Number(this.othersAmount[1].value));
            //   el.commission_amt = (el.partial_saleamt * (Number(el.commission) / 100)).toFixed(2);
            // }
          }

          if ((el.dcdt < "2021-04-01" && (el.agent_id != '1470' && el.agent_id != '1849' && el.agent_id != '1476'))) {
            el.commission_amt = 0;
            el.maxcomm_amt = 0;
        
          }
        })
      });

    }
    this.setSplDiscDetails();
    let temp_commtot = 0;
    this.selectedBillDetails.forEach((element) => {
      if (element.dcdt < this.commDetails[0]['effective_from']) {
        element.commission_amt = 0;
        element.maxcomm_amt = 0;
      }
      //change this to tofixed for precision
      this.commissionDetails.inv_commission += Number(element.commission_amt);
      this.commissionDetails.inv_commission = Number(this.commissionDetails.inv_commission.toFixed(2));

      this.commissionDetails.party_dis_exceeds += Number(Number(
        element.exceeds_to_days_amt
      ).toPrecision(3));
      this.commissionDetails.extra_dis_deduction += Number(
        element.extra_dis_deduct_amt.toFixed(2)
      );
      this.commissionDetails.exceeds_from_days += Number(
        element.exceeds_final_days_amt.toFixed(2)
      );
      this.commissionDetails.othersDiscountDeduction = Number(
        this.othersDiscountDeduction.toFixed(2)
      );
      this.commissionDetails.exceedisc_ded += Number(
        element.exceedisc_dedamt.toFixed(2)
      );
      this.commissionDetails.discdiff_amt = Number(
        this.discdiff_amt.toFixed(2)
      );
      this.commissionDetails.spl_discDed = Number(
        this.spl_discDed.toFixed(2)
      );
      // this.commissionDetails.total_commission_pending += Number(this.othersDiscountDeduction);
    });

    this.returnDedDetails.forEach((element) => {
      this.commissionDetails.return_deduction += Number(
        element.return_deduct_amt
      );
    });
    this.selectedSplBills.forEach((e) => {
      this.commissionDetails.spl_commission_totamt += Number(
        e.spl_commission_amt
      );
    });
    this.selectedTrimsBills.forEach((el) => {
      this.commissionDetails.trims_ded_totamt += Number(
        el.trims_ded_amt
      );
    });
    // this.commissionDetails.total_commission = (this.commissionDetails.inv_commission + this.commissionDetails.spl_commission_totamt)
    this.setTotalAmount();

    this.commissionDetails.total_commission = this.tot_data.earnd_tot

    this.commissionDetails.total_commission = Math.round(Number(
      this.commissionDetails.total_commission.toFixed(2)
    ));
    this.commissionDetails.total_commission_pending =
      Number(this.commissionDetails.total_commission) -
      Number(
        this.commissionDetails.party_dis_exceeds +
        Number(this.commissionDetails.extra_dis_deduction) +
        Number(this.commissionDetails.exceeds_from_days) +
        Number(this.commissionDetails.othersDiscountDeduction) +
        Number(this.commissionDetails.return_deduction) +
        Number(this.commissionDetails.exceedisc_ded) +
        Number(this.commissionDetails.discdiff_amt) +
        Number(this.commissionDetails.spl_discDed) +
        Number(this.commissionDetails.trims_ded_totamt) +
        Number(this.tot_data.diff_tot)
      );

    this.commissionDetails.total_commission_pending = Math.round(Number(
      this.commissionDetails.total_commission_pending.toFixed(2)
    ));

    this.commissionDetails.total_deduction = Number(
      this.commissionDetails.party_dis_exceeds +
      Number(this.commissionDetails.extra_dis_deduction) +
      Number(this.commissionDetails.exceeds_from_days) +
      Number(this.commissionDetails.othersDiscountDeduction) +
      Number(this.commissionDetails.return_deduction) +
      Number(this.commissionDetails.exceedisc_ded) +
      Number(this.commissionDetails.discdiff_amt) +
      Number(this.commissionDetails.spl_discDed) +
      Number(this.commissionDetails.trims_ded_totamt) +
      Number(this.tot_data.diff_tot)
    );

    this.commissionDetails.total_deduction = Math.round(Number(
      this.commissionDetails.total_deduction.toFixed(2)
    ));


  }
  SplbillComm() {
    if (this.selectedSplBills.length > 0) {
      this.selectedSplBills.forEach(el => {
        el.spl_commission_amt = Number(el.spl_commission_amt)
      });
    }

  }
  TrimsbillDet() {
    if (this.selectedTrimsBills.length > 0) {
      this.selectedTrimsBills.forEach(el => {
        // 50% Of The Bill Amt
        el["trims_ded"] = 50;
        el["trims_ded_amt"] = Number(Number(el.pending_amount) * .5).toFixed(2);

      });
    }

  }
  setTotalAmount() {
    let tot = 0
    let ttt = 0;
    if (!this.total_det) {
      this.selectedBillDetails.forEach(el => {
        // 50% Of The Bill Amt
        // Math.round(Number(
        //   this.commissionDetails.total_deduction.toFixed(2)
        // ));
        this.tot_data.inv_tot += Number(el.pending_amount);
        this.tot_data.inv_tot = Number(this.tot_data.inv_tot.toFixed(2));

        this.tot_data.goods_tot += Number(el.invoice_sale_amount);
        this.tot_data.goods_tot = Number(this.tot_data.goods_tot.toFixed(2));

        tot += Number(el.invrate);
        ttt = Number(tot.toFixed(2));

        this.tot_data.tax_tot += Number(el.taxamt);
        this.tot_data.tax_tot = Number(this.tot_data.tax_tot.toFixed(2));

        this.tot_data.sale_tot += Number(el.sale_amt);
        this.tot_data.sale_tot = Number(this.tot_data.sale_tot.toFixed(2));

        this.tot_data.earnd_tot += Number(el.maxcomm_amt);
        this.tot_data.earnd_tot = Number(this.tot_data.earnd_tot.toFixed(2));

        this.tot_data.act_tot += Number(el.commission_amt);
        this.tot_data.act_tot = Number(this.tot_data.act_tot.toFixed(2));

        el["diff"] = (Number(el.maxcomm_amt) - Number(el.commission_amt)).toFixed(2);

        this.tot_data.diff_tot += Number(el.diff);
        this.tot_data.diff_tot = Number(this.tot_data.diff_tot.toFixed(2));

        this.tot_data.balsale_tot += (Number(el.bal_sale_amt) > 0) ? Number(el.bal_sale_amt) : 0;
        this.tot_data.balsale_tot = Number(this.tot_data.balsale_tot.toFixed(2));

        this.tot_data.retsale_tot += (Number(el.ret_sale) > 0) ? Number(el.ret_sale) : 0;
        this.tot_data.retsale_tot = Number(this.tot_data.retsale_tot.toFixed(2));

        this.tot_data.spldisc_tot += (Number(el.spl_discamt) > 0) ? Number(el.spl_discamt) : 0;
        this.tot_data.spldisc_tot = Number(this.tot_data.spldisc_tot.toFixed(2));
     

      });
    }
    this.total_det = true;

  }
  setExtraDisDeductions() {
    this.selectedBillDetails.forEach((element) => {
      //%5 instead of element.dispercent set to default discount exceed percentage
      if (Number(element.disper) > element.dispercent && element.dcdt >= "2020-04-01") {
        // let deduct_percent =
        //   (Number(element.disper) - element.dispercent) / 2;
        let deduct_percent = Number(element.agent_dis_deduct);
        element["extra_dis_deduct_amt"] = Number(
          (
            Number(element.invoice_sale_amount) *
            (deduct_percent / 100)
          ).toFixed(2)
        );
        element["extra_dis_deduct_percent"] = deduct_percent;
        // Not Applicable (Because always dis % Comes From Ledger For Invoice Entry.So, Not Greater Than Ledger %)
        element["extra_dis_deduct_amt"] = 0;

      } else {
        element["extra_dis_deduct_amt"] = 0;
        element["extra_dis_deduct_percent"] = 0;
      }
    });
  }
  setExceedsFinalDaysDetails() {
    this.selectedBillDetails.forEach((element) => {
      if (
        (Number(element.recvd_days) >
          Number(this.commDetails[this.commDetailsLength - 1].from_days)) && element.dcdt >= "2020-04-01"
      ) {
        element["exceeds_final_days_amt"] = Number(
          (Number(element.invoice_sale_amount) / 2).toFixed(2)
        );
        element["exceeds_final_days_amt"] = 0;

      } else {
        element["exceeds_final_days_amt"] = 0;
      }
    });


  }
  setExceedsDaysDeductions() {

    this.selectedBillDetails.forEach((element) => {

      // instead of commission first limit days, party dis days taken from ledger

      if ((Number(element.recvd_days) > Number(element.dis_days)) && element.dcdt >= "2020-04-01" && Number(element.disamt) > 0) {

        let deduct_percent = Number(element.dispercent) / 2;
        element["exceeds_to_days_percent"] = deduct_percent;
        element["exceeds_to_days_amt"] = Number(
          (
            Number(element.invoice_sale_amount) *
            (deduct_percent / 100)
          ).toFixed(2)
        );
        element["exceeds_to_days_amt"] = 0;
      } else {
        element["exceeds_to_days_percent"] = 0;
        element["exceeds_to_days_amt"] = 0;
      }
    });
  }
  setExceeddiscountDed() {
    this.selectedBillDetails.forEach((element) => {

      // instead of commission first limit days, party dis days taken from ledger
      //If Cash Discount Entered ded_amt calculated from That.
      // if ((element.dcdt >= "2021-04-01" && (element.agent_id != '1470' && element.agent_id != '1849' && element.agent_id != '1476')) || (element.dcdt >= "2020-04-01" && (element.agent_id == '1470' && element.agent_id == '1849' && element.agent_id == '1476'))) {

        if ((element.dcdt >= "2021-04-01" && element.agent_id != '1470') || (element.dcdt >= "2020-04-01" && element.agent_id == '1470')) {

        if (Number(this.othersAmount[1].value) > 0 || Number(element.disamt) > 0) {
          element["exceedisc_dedamt"] = Number(
            (
              Number(element.ref_dis) *
              (element.latedis_ded / 100)
            ).toFixed(2)
          );

          if (!element["exceedisc_dedamt"]) {
            element["exceedisc_dedamt"] = 0;
          }

        }
        else {
          element["exceedisc_dedamt"] = 0;
        }

      }
      else {
        element["exceedisc_dedamt"] = 0;
      }
    });


  }
  setReturnDedDetails() {
    let credit_id = [];
    this.returnBillDetails.forEach((el) => {
      if (el.isChecked == true) {
        credit_id.push(el.creditid);
      }
    });
    if (this.returnBillDetails.length > 0) {
      this.returnDedDetails = this.returnDedDetailsBackUp.filter(
        function (e) {
          return !(this.indexOf(e.creditid) < 0);
        },
        credit_id
      );
      this.returnDedDetails.forEach((element) => {
        if ((element.dcdt >= '2021-04-01' && element.agentid != '1470') || (element.dcdt >= '2020-04-01' && element.agentid == '1470')) {
          if (Number(element.recvd_days) > 60) {
            // above days
            if (element.box_type == "WITH BOX" || !element.box_type) {
              element["return_deduct_amt"] =
                Number(element.total_pcs) *
                150;
            } else {
              element["return_deduct_amt"] =
                Number(element.total_pcs) *
                150;
            }
          } else {
            // below days
            if (element.box_type == "WITH BOX" || !element.box_type) {
              element["return_deduct_amt"] =
                Number(element.total_pcs) *
                20;
            } else {
              element["return_deduct_amt"] =
                Number(element.total_pcs) *
                40;
            }
          }
        }
        else {
          element["return_deduct_amt"] = 0;
        }
      });
    }

  }
  setOthersDiscountDetails() {
    let othersDisAmt = this.othersAmount.filter((el) => el.label == "DISCOUNT");
    this.othersDiscount = othersDisAmt[0].value;
    let isInvExists = false;
    let eligibleDisAmt = 0;
    this.othersDiscountDeduction = Number(this.othersDiscount);
    let tem_amt = 0;
    tem_amt = Number(this.othersDiscount);
    this.selectedBillDetails.forEach((element) => {
      if (element.dcdt >= "2020-04-01") {
        if ((Number(element.recvd_days) < Number(element.dis_days))) {
          eligibleDisAmt += Number(element.disamt);
        }
        if ((Number(element.recvd_days) > Number(element.dis_days))) {
          isInvExists = true;
        }
      }
    });

    if (!isInvExists) {
      this.othersDiscountDeduction = 0;
    } else {
      this.othersDiscountDeduction -= eligibleDisAmt;

      if (this.othersDiscountDeduction < 0) {
        this.othersDiscountDeduction = 0;
      }
    }

    this.othersDiscountDeduction = Number(this.othersDiscountDeduction) / 2;

    this.othersDiscountDeduction = 0;
    if (tem_amt > 0) {
      this.discdiff_amt = this.totalDiscountDetails['totalDiscount'] - tem_amt;
      this.discdiff_amt = -1 * (this.discdiff_amt)
      //For Other Discount Less Than act-Discount Amt difference amt = 0;
      if (this.discdiff_amt < 0) {
        this.discdiff_amt = 0;
      }
      else if (!this.discdiff_amt) {
        this.discdiff_amt = 0;
      }
    }
    else {
      this.discdiff_amt = 0;
    }

  }

  setSplDiscDetails() {

    let tem_discamt = 0;

    // if (this.mode == 'Add') {
    //   let prev_disc = Number(this.selectedBillDetails[0].dispercent)
    //   if (Number(this.othersAmount[1].value) > 0 || (this.selectedBillDetails[0].disc_applicable == "YES" || Number(this.selectedBillDetails[0].spl_disc) > 0)) {

    //     tem_discamt = this.totalDiscountDetails['totalDiscount'] / prev_disc;
    //     this.spl_discDed = (tem_discamt * Number(this.selectedBillDetails[0].spl_disc)) / 2;

    //     if (!this.spl_discDed) {
    //       this.spl_discDed = 0;
    //     }
    //   }
    // }
    // else if (this.mode != 'Add') {
    this.spl_discDed = 0;
    this.selectedBillDetails.forEach(e => {
      // let temp_sale = 0;
      if (Number(this.voucherData.spl_d) > 0) {
        // If cash Discount Comes(othersAmount (discount)) totalDiscount not calculated for tem_amt
        if ((e.dcdt >= "2021-04-01" && e.agent_id != '1470') || (e.dcdt >= "2020-04-01" && e.agent_id == '1470')) {
          tem_discamt = Number(e.sale_amt);
          if (Number(e.bal_sale_amt) > 0) {
            tem_discamt = Number(e.bal_sale_amt)
          }
          if (Number(e.partial_saleamt) > 0) {
            tem_discamt = Number(e.partial_saleamt)
          }

          // e["spl_discamt"] = (tem_discamt * Number(this.voucherData.spl_d) / 100) / 2;
          e["spl_discamt"] = (tem_discamt * Number(this.voucherData.spl_d) / 100) / 2;
          e["spl_discamt"] = Number(e["spl_discamt"].toFixed(2))
          this.spl_discDed += e["spl_discamt"];
        }
        if (!this.spl_discDed) {
          e["spl_discamt"] = 0;
          this.spl_discDed += e["spl_discamt"];
        }
      }
    });

    // }

  }
  othersValueChange() {
    this.voucherData.othersTotAmt = 0;
    this.othersAmount.forEach((element) => {
      if (element.label != "EXCESS") {
        this.voucherData.othersTotAmt += Number(element.value);
      } else {
        this.voucherData.othersTotAmt -= Number(element.value);
      }
    });

    this.getPartialOutstandingBillDetails();
    // this.voucherData.total_pending = 0;
    // this.voucherData.total_pending =
    //   Number(this.voucherData.totalRetAmt) +
    //   Number(this.voucherData.othersTotAmt) +
    //   Number(this.voucherData.amount) -
    //   Number(this.voucherData.totalSelectedAmt);
  }
  getBillPendingDetails() {
    let params = {
      party_id: this.voucherData.party_id,
      agent_id: this.voucherData.agent_id,
      ref_date: this.voucherData.ref_date,
    };

    params["ref_date"] = this.datePipe.transform(
      params["ref_date"],
      "yyyy-MM-dd"
    );

    this.salesservice.getBillPendingDetails(params).then((res: any) => {
      if (res.commDetails.length <= 0) {
        swal("Sales Person Commission Master not available");
        return;
      }
      this.billDetails = res.data;

      this.spl_Bills = res.splBills;
      this.trims_Bills = res.trimsBills;
      this.setBillDetails();
      this.commDetails = res.commDetails;
      this.voucherData.spl_d = this.billDetails[0].spl_disc;
      this.voucherData.max_per = this.commDetails[0].commission;
      this.voucherData.max_per1 = this.commDetails[0].commission;
      this.commDetailsLength = res.commDetails.length;
      this.returnDedDetails = res.returnDedDetails;
      this.returnDedDetailsBackUp = [...res.returnDedDetails];
      this.initialbillDetails = [...res.data];
      if (res.data.length > 0) {
        this.billDetails.forEach((element) => {
          element["isChecked"] = false;
        });
        this.getOutstandingBillDetails(res.data);
      } else {
        let obj = {
          no_of_bills: "",
          total_amount: "",
        };
        this.outstandingBillDetails = new Array(1).fill(obj);

      }

      if (res.returnDetails.length > 0) {
        this.returnBillDetails = res.returnDetails;
        //change
        // this.voucherData.totalRetAmt = 0;
        // this.returnBillDetails.forEach((element) => {
        //   this.voucherData.totalRetAmt += Number(
        //     parseFloat(element.ret_invoice_amount).toFixed(2)
        //   );
        // });
      } else {
        let obj = {
          creditno: "",
          return_date: "",
          total_pcs: "",
          ret_invoice_amount: "",
          ret_sale_amount: "",
        };
        this.returnBillDetails = new Array(3).fill(obj);
      }

    });
  }
  setReturnsaleAmtDet() {
    let retless_sale = 0;
    if (this.returnDedDetails.length > 0 && Number(this.returnBillDetails[0].ret_sale_amount) > 0) {
      this.returnBillDetails.forEach((el, ind) => {
        el.ret_sale_amount = Number(el.ret_sale_amount);

        this.selectedBillDetails.forEach((e, index) => {
          // e["ret_sale"] = 0
          if ((e.dcdt < "2021-04-01" && (e.agent_id != '1470' && e.agent_id != '1849' && e.agent_id != '1476'))) {
            if (ind == index && el.isChecked ==  true) {
              e.commission_amt = 0;
              e.maxcomm_amt = 0;
              e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
              e["bal_sale_amt"] = (e.sale_amt - Number(el.ret_sale_amount)).toFixed(2);
              e["ret_sale"] = Number(el.ret_sale_amount);
          
            }
          }
          else if (e.commission_amt) {
            if (ind == index && el.isChecked ==  true) {
            
              e["sale_amt"] = ((Number(e.pending_amount) - Number(e.taxamt))).toFixed(2);
              e["ret_sale"] = Number(el.ret_sale_amount);
              e["bal_sale_amt"] = Number(e.sale_amt) - Number(el.ret_sale_amount);
              e.commission_amt = (e.bal_sale_amt * (Number(e.commission) / 100)).toFixed(2);
              e.maxcomm_amt = (e.bal_sale_amt * (Number(this.voucherData.max_per) / 100)).toFixed(2);

              if (e["sale_amt"] < Number(el.ret_sale_amount)) {
           
                e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt)
                e["ret_sale"] = Number(e.pending_amount) - Number(e.taxamt);
                e["bal_sale_amt"] = 0;

                e.commission_amt = 0;
                e.maxcomm_amt = 0;
                retless_sale = -((Number(e.pending_amount) - Number(e.taxamt)) - Number(el.ret_sale_amount)).toFixed(2);

              }
           
            }
            else if (index == 1 && retless_sale > 0 && el.isChecked ==  true) {
              e["sale_amt"] = (Number(e.pending_amount) - Number(e.taxamt)).toFixed(2);
              e["bal_sale_amt"] = e.sale_amt - retless_sale;
              e["ret_sale"] = Number(retless_sale);
              e.commission_amt = (Number(e.bal_sale_amt) * (Number(e.commission) / 100)).toFixed(2);
              e.maxcomm_amt = (Number(e.bal_sale_amt) * (Number(this.voucherData.max_per) / 100)).toFixed(2);
           
            }
            else {
              e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
              e["ret_sale"] = (e.ret_sale) ? e.ret_sale : 0;
              // e["sale_amt"] = Number(e.sale_amt) - Number(e.ret_sale);
              e.commission_amt = ((e.sale_amt - Number(e.ret_sale)) * (Number(e.commission) / 100)).toFixed(2);
              e["max_per"] = Number(this.voucherData.max_per);
              e["maxcomm_amt"] = ((e.sale_amt - Number(e.ret_sale)) * (Number(e.max_per) / 100)).toFixed(2);

            }

          }
        });
      });
    }
    else {
      this.selectedBillDetails.forEach(e => {

        if ((e.dcdt < "2021-04-01" && (e.agent_id != '1470' && e.agent_id != '1849' && e.agent_id != '1476'))) {


          e.commission_amt = 0;
          e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
          // inv +=  Number(e["pending_amount"]);
          // tax += Number(e["sale_amt"]);
          e.max_per = 0;
          e.maxcomm_amt = 0;
          // e.diff = 0;
 
          console.log("Zero Sale Amt", e)
        }
        else if (e.commission_amt) {
          if (Number(e.pending_amount) < Number(e.total_amount)) {
            e["sale1_amt"] = Number(e.pending_amount) - Number(e.taxamt);
            // e["sale1_amt"] = Number(e.total_amount) - Number(e.taxamt);
            // if (Number(e.pending_amount) < Number(e.sale1_amt)) {
            //   e["sale_amt"] = Number(e.pending_amount);
            // }
            // else {
            //   e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
            // }

            e["sale_amt"] = Number(e.pending_amount);
            if (Number(e.bal_tax) < Number(e.sale1_amt) && Number(e.bal_tax) > 0) {
              e["sale_amt"] = Number(e.pending_amount) - Number(e.bal_tax);
            }
            e.commission_amt = (e.sale_amt * (Number(e.commission) / 100)).toFixed(2);
            e["max_per"] = Number(this.voucherData.max_per);
            e["maxcomm_amt"] = (e.sale_amt * (Number(e.max_per) / 100)).toFixed(2);
          }
          else {
            e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
            e.commission_amt = (e.sale_amt * (Number(e.commission) / 100)).toFixed(2);
            e["max_per"] = Number(this.voucherData.max_per);
            e["maxcomm_amt"] = (e.sale_amt * (Number(e.max_per) / 100)).toFixed(2);
         
          }




          
        }
      
      });

    }
  
  }
  setBillDetails() {
    if (this.billDetails.length < 6) {
      let obj = {
        invoiceno: "-",
        invoice_date: "-",
        total_amount: 0,
        pending_amount: 0,
        recvd_days: 0,
      };
      for (let i = this.billDetails.length; i <= 6; i++) {
        this.billDetails.push(obj);
      }
    }
  }
  checkMultiNo(type) {
    let temp = type.split(",");
    if (temp.length > 1) {
      swal("Multiple Cheque Entry Not Allowed!!!");
      this.voucherData.bank_ref_no = 0;
    }
  }
  onSelectAllClicked(event) {
    let isChecked = true;

    if (event.target.checked) {
      $(".select_invoice").prop("checked", true);
      isChecked = true;
      this.selectedBillDetails = [...this.initialbillDetails];
    } else {
      isChecked = false;
      this.voucherData.totalSelectedAmt = 0;
      $(".select_invoice").prop("checked", false);
    }

    this.billDetails.forEach((element) => {
      element.isChecked = isChecked;
    });

    this.getPartialOutstandingBillDetails();
  }

  onSelectClicked(event, ind) {
    if (event.target.checked) {
      // let canSelect = this.billDetails.every((el, index) => {
      //   if (index < ind) {
      //     return el.isChecked == true;
      //   } else {
      //     return true;
      //   }
      // });
      // if (ind == 0 || canSelect) {
      this.billDetails[ind].isChecked = true;
      // } else {
      //   $("#select_invoice" + ind).prop("checked", false);
      //   this.billDetails[ind].isChecked = false;
      //   swal("Please Select Previous Bills");
      // }
    } else {
      // this.billDetails.forEach((element, index) => {
      //   if (index >= ind) {
      this.billDetails[ind].isChecked = false;
      // $("#select_invoice" + index).prop("checked", false);
      //   }
      // });
    }
    this.selectedBillDetails = this.billDetails.filter(
      (el) => el.isChecked == true
    );
    this.getPartialOutstandingBillDetails();
    this.getTotalDiscountDetails();
  }
  onSelectSplClicked(event, ind) {
    if (event.target.checked) {

      this.spl_Bills[ind].isChecked = true;

    } else {

      this.spl_Bills[ind].isChecked = false;

    }
    this.selectedSplBills = this.spl_Bills.filter(
      (el) => el.isChecked == true
    );

  }
  onSelectTrimsClicked(event, ind) {
    if (event.target.checked) {

      this.trims_Bills[ind].isChecked = true;

    } else {

      this.trims_Bills[ind].isChecked = false;

    }
    this.selectedTrimsBills = this.trims_Bills.filter(
      (el) => el.isChecked == true
    );

  }
  getTotalDiscountDetails() {
    this.totalDiscountDetails['totalDiscount'] = 0
    this.totalDiscountDetails['no_of_bills'] = 0
    this.billDetails.forEach((el) => {
      if (el.isChecked) {
        this.totalDiscountDetails['totalDiscount'] += Number(el.ref_dis);
        this.totalDiscountDetails['no_of_bills']++;
        // console.log(this.totalDiscountDetails['totalDiscount'], "Check-tot Disc")
      }
    });

    this.totalDiscountDetails['totalDiscount'] = Number(this.totalDiscountDetails['totalDiscount'].toFixed(2));
    // console.log(this.totalDiscountDetails['totalDiscount'])
  }

  onSelectReturnAllClicked(event) {
    let isChecked = true;

    if (event.target.checked) {
      $(".select_return_invoice").prop("checked", true);
      isChecked = true;
      // this.selectedBillDetails = [...this.initialbillDetails];
    } else {
      isChecked = false;
      // this.voucherData.totalSelectedAmt = 0;
      $(".select_return_invoice").prop("checked", false);
    }

    this.returnBillDetails.forEach((element) => {
      element.isChecked = isChecked;
    });

    this.getReturnBillDetails();
  }

  onSelectReturnClicked(event, ind) {
    if (event.target.checked) {
      // let canSelect = this.billDetails.every((el, index) => {
      //   if (index < ind) {
      //     return el.isChecked == true;
      //   } else {
      //     return true;
      //   }
      // });
      // if (ind == 0 || canSelect) {
      this.returnBillDetails[ind].isChecked = true;
      // } else {
      //   $("#select_return_invoice" + ind).prop("checked", false);
      //   this.billDetails[ind].isChecked = false;
      //   swal("Please Select Previous Bills");
      // }
    } else {
      // this.billDetails.forEach((element, index) => {
      //   if (index >= ind) {
      this.returnBillDetails[ind].isChecked = false;
      // $("#select_return_invoice" + index).prop("checked", false);
      //   }
      // });
    }
    // this.selectedBillDetails = this.billDetails.filter(
    //   (el) => el.isChecked == true
    // );
    this.getReturnBillDetails();
  }

  getReturnBillDetails() {
    this.voucherData.totalRetAmt = 0;

    this.returnBillDetails.forEach((element) => {
      if (element.isChecked == true) {
        this.voucherData.totalRetAmt += Number(
          parseFloat(element.ret_invoice_amount).toFixed(2)
        );
      }
    });

    this.getPartialOutstandingBillDetails();

  }

  getPartialOutstandingBillDetails() {
    this.nonSelectedBillDetails = this.billDetails.filter(
      (el) => el.isChecked == false
    );
    this.getOutstandingBillDetails(this.nonSelectedBillDetails);

    let reqArrayIndex = _.findLastIndex(
      this.selectedBillDetails,
      function (el) {
        return el["isChecked"] == true;
      }
    );

    this.partialBillDetails = [];
    if (reqArrayIndex >= 0) {
      let partialBill = [];
      partialBill.push({ ...this.selectedBillDetails[reqArrayIndex] });

      this.voucherData.totalSelectedAmt = 0;

      this.selectedBillDetails.forEach((element) => {
        this.voucherData.totalSelectedAmt += parseFloat(element.pending_amount);
      });
      let pendingBillAmount = (Number(partialBill[0].pending_amount) - (Number(this.voucherData.totalSelectedAmt) - Number(this.voucherData.amount))) + Number(this.voucherData.othersTotAmt);

      partialBill[0]['pendingBillAmount'] = pendingBillAmount;

      partialBill[0].pending_amount =
        Number(this.voucherData.amount) + Number(this.voucherData.othersTotAmt) - Number(this.voucherData.totalSelectedAmt) + Number(this.voucherData.totalRetAmt);
      if (partialBill[0].pending_amount < 0) {
        partialBill[0].pending_amount = partialBill[0].pending_amount * -1;
        this.partialBillDetails.push({ ...partialBill[0] });
      } else {
        let obj1 = {
          invoiceno: "",
          invoice_date: "",
          pending_amount: "",
          pendingBillAmount: 0
        };
        this.partialBillDetails = new Array(1).fill(obj1);
      }
    }
    this.voucherData.total_pending = 0;
    this.voucherData.total_pending =
      Number(this.voucherData.totalRetAmt) +
      Number(this.voucherData.othersTotAmt) +
      Number(this.voucherData.amount) -
      Number(this.voucherData.totalSelectedAmt);
    this.voucherData.total_pending = Number(this.voucherData.total_pending.toFixed(2));
  }

  getOutstandingBillDetails(data) {
    this.outstandingBillDetails = [
      {
        no_of_bills: data.length,
        total_amount: 0,
      },
    ];
    data.filter((bill) => {
      this.outstandingBillDetails[0].total_amount =
        parseFloat(bill.total_amount) +
        parseFloat(this.outstandingBillDetails[0].total_amount);
    });
  }

  restoreBillDetails() {
    this.billDetails = [];
    this.returnBillDetails = [];
    this.outstandingBillDetails = [];
    let obj1 = {
      invoiceno: "",
      invoice_date: "",
      pending_amount: "",
      pendingBillAmount: 0
    };
    this.partialBillDetails = new Array(1).fill(obj1);
    this.getBillPendingDetails();
  }

  getViewPaymentVoucherList() {
    let params = {
      pay_id: this.voucherData.pay_id,
    };

    let that = this;

    that.salesservice.getViewPaymentVoucherList(params).then((res: any) => {
      let tr = 0;
      let tax = 0;
      that.canShow = true;
      that.commDetails = res.commDetails;
      that.commDetailsLength = res.commDetails.length;
      that.viewDetails = res.data;
      that.selectedBillDetails = JSON.parse(
        that.viewDetails[0].selectedBillDetails
      );
      that.partialBillDetails = JSON.parse(
        that.viewDetails[0].partialBillDetails
      );
      that.billDetails = JSON.parse(that.viewDetails[0].selectedBillDetails);
      that.selectedBillDetails.forEach(e => {

        if ((e.dcdt < "2021-04-01" && (e.agent_id != '1470' && e.agent_id != '1849' && e.agent_id != '1476'))) {


          e.commission_amt = 0;
          e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
          // inv +=  Number(e["pending_amount"]);
          tax += Number(e["sale_amt"]);
          e.max_per = 0;
          e.maxcomm_amt = 0;
          // e.diff = 0;
      
        }
        else if (e.commission_amt) {


          e["sale_amt"] = Number(e.pending_amount) - Number(e.taxamt);
          e.commission_amt = (e.sale_amt * (Number(e.commission) / 100)).toFixed(2);
          e["max_per"] = Number(this.voucherData.max_per);
          e["maxcomm_amt"] = (e.sale_amt * (Number(e.max_per) / 100)).toFixed(2);
          // e["diff"] = (Number(e.maxcomm_amt) - Number(e.commission_amt)).toFixed(2);

          // e.commission_amt = 30000
          tr += Number(e["sale_amt"])



        }
      });
      //For Return Bill sale Amt Deduction


      this.setBillDetails();
      this.getTotalDiscountDetails();
      that.othersAmount = JSON.parse(that.viewDetails[0].othersAmount);
      that.returnDedDetails = JSON.parse(that.viewDetails[0].returnDedDetails);
      that.returnDedDetailsBackUp = JSON.parse(that.viewDetails[0].returnDedDetails);
      that.returnBillDetails = JSON.parse(
        that.viewDetails[0].returnBillDetails
      );
      // if(that.returnBillDetails.length == 0){
      //   that.returnBillDetails[0].ret_sale_amount = 0;
      // }
      that.commissionDetails = JSON.parse(
        that.viewDetails[0].commissionDetails
      );
      that.partialBillDetails = JSON.parse(
        that.viewDetails[0].partialBillDetails
      );
      that.outstandingBillDetails = JSON.parse(
        that.viewDetails[0].outstandingBillDetails
      );
      // this.setReturnsaleAmtDet();

    });
  
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  oncheckemptyrow() {
    this.saveBillDetails();
  }

  saveBillDetails(): void {
    if (!this.findata_exist) {
      this.selectedBillDetails.forEach(el => {
        if ((el.dcdt < "2021-04-01" && (el.agent_id != '1470' && el.agent_id != '1849' && el.agent_id != '1476'))) {
          this.fin_year_data.march_net += Number(el.pending_amount);
          this.fin_year_data.march_tax += Number(el.taxamt);
          this.fin_year_data.march_sale += Number(el["sale_amt"]);
        }
        else if ((el.dcdt >= "2021-04-01" && (el.agent_id != '1470' && el.agent_id != '1849' && el.agent_id != '1476')) || (el.agent_id == '1470' || el.agent_id == '1849' || el.agent_id == '1476')) {
          this.fin_year_data.apr_net += Number(el.pending_amount);
          this.fin_year_data.apr_tax += Number(el.taxamt);
          this.fin_year_data.apr_sale += Number(el["sale_amt"]);
          el["ret_sale"] = (el.ret_sale) ? el.ret_sale : 0;
          this.fin_year_data.apr_retsale += Number(el.ret_sale);
   

        }

      });
      let temp_tot = 0;
      if (Number(this.fin_year_data.apr_sale) > 0) {

        temp_tot = Number(this.fin_year_data.apr_sale) - (-(this.voucherData.total_pending) + this.fin_year_data.apr_retsale)
        this.fin_year_data.apr_sale = temp_tot;
      }
      else {
        this.fin_year_data.apr_sale = 0;
      }

    }
    this.findata_exist = true;
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Payment Voucher?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isApiCalled = true;

      let returnBillDetails = that.returnBillDetails.filter(element => element.isChecked == true);
      that.voucherData.ref_date = that.datePipe.transform(
        that.voucherData.ref_date,
        "yyyy-MM-dd"
      );
      let params: any = Object.assign({}, that.voucherData);
      params["fin_data"] = Object.assign({}, that.fin_year_data);
      params["tabevent"] = undefined;
      params["selectedBillDetails"] = JSON.stringify(that.selectedBillDetails);
      params["othersAmount"] = JSON.stringify(that.othersAmount);
      params["returnDedDetails"] = JSON.stringify(that.returnDedDetails);
      params["returnBillDetails"] = JSON.stringify(returnBillDetails);
      params["commissionDetails"] = JSON.stringify(that.commissionDetails);
      params["partialBillDetails"] = JSON.stringify(that.partialBillDetails);
      params["selectedTrimsBills"] = JSON.stringify(that.selectedTrimsBills);
      params["selectedSplBills"] = JSON.stringify(that.selectedSplBills);
      params["outstandingBillDetails"] = JSON.stringify(
        that.outstandingBillDetails
      );

      that.isLoading = true;
      that.salesservice
        .saveBillDetails(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            that.isApiCalled = false;
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isApiCalled = false;
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  ChequeReturn(): void {
    let that = this;
    that.isLoading = true;
    swal({
      title: "Cheque Return details \n Party payment amount return : " + "<span style = \"color : red\">" + (-1) * that.voucherData['amount'] + "</span>" + "\n Sales Person Commission : " + "<span style = \"color : red\">" + (-1) * that.voucherData['commission'] + "</span>",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "No, keep it",
    }).then(function () {

      that.isApiCalled = true;

      let params: any = Object.assign({}, that.voucherData);
      params["tabevent"] = undefined;
      that.isLoading = true;
      that.salesservice.chequeReturnDetails(params).then(function (res: any) {
        that.isLoading = false;
        if (that.saveEvent) {
          that.saveEvent.emit();
        }
        if (res.success) {
          that.toasterService.pop({
            bodyOutputType: 1,
            type: "success",
            title: "SUCCESS",
            body: res.message,
          });
          if (that.mode == "Add") {
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);
          } else {
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);
          }
        } else {
          that.isApiCalled = false;
          swal("ERROR", res.message, "error");
        }
      }).catch(function (error: any) {
        that.isApiCalled = false;
        that.isLoading = false;
        let res = JSON.parse(error._body);
        swal("ERROR", res.message, "error");
      });
    }).catch((dismiss) => {

    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/paymentVoucher/paymentVoucher.ts